import * as actionTypes from "../actionTypes/Index";

import { IActionType } from "../../interfaces/Index";
import { agentAssignmentInitialState } from "./InitialState";

const initialState = { ...agentAssignmentInitialState };

export default function agentAssignmentReducer(
  state = initialState,
  action: IActionType
) {
  switch (action.type) {
    case actionTypes.AGENT_CHATWOOT_ASSIGNEMNT_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        agentChatwootAssignmentCompleted: false
      });
    }
    case actionTypes.AGENT_CHATWOOT_ASSIGNMENT_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }
    case actionTypes.AGENT_CHATWOOT_ASSIGNMENT_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        agentChatwootAssignmentCompleted: true,
      });
    }
    case actionTypes.AGENT_STORE_ASSIGNMENT_INIT: {
      return Object.assign({}, state, {
        isLoading: true,
        agentStoreAssignmentCompleted: false
      });
    }
    case actionTypes.AGENT_STORE_ASSIGNMENT_FAIL: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: true,
        error: action.error,
      });
    }
    case actionTypes.AGENT_STORE_ASSIGNMENT_SUCCESS: {
      return Object.assign({}, state, {
        isLoading: false,
        isError: false,
        agentStoreAssignmentCompleted: true,
      });
    }
    default:
      return state;
  }
}
